import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/[locale]/products/miningHub/MiningHubContent.tsx");
